"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var scenario_actions_1 = __importDefault(require("../../redux/scenario/scenario.actions"));

var global_actions_1 = __importDefault(require("../../redux/global/global.actions"));

var storage_actions_1 = __importDefault(require("../../redux/storage/storage.actions"));

var with_store_hoc_1 = __importDefault(require("../../redux/with-store.hoc"));

var global_state_1 = require("../../redux/global/global.state");

var global_selectors_1 = require("../../redux/global/global.selectors");

var top_navigation_container_1 = __importDefault(require("../top-navigation/top-navigation.container"));

var overview_content_container_1 = __importDefault(require("../overview-content/overview-content.container"));

var editor_content_component_1 = __importDefault(require("../editor-content/editor-content.component"));

var deploy_scenario_button_container_1 = __importDefault(require("../deploy-scenario-button/deploy-scenario-button.container"));

var save_scenario_button_container_1 = __importDefault(require("../save-scenario-button/save-scenario-button.container"));

var scenario_editor_styles_1 = require("./scenario-editor.styles");

var useInitScenarioEditor = function useInitScenarioEditor(_ref) {
  var initialScenarioState = _ref.initialScenarioState,
      images = _ref.images,
      initialAppMode = _ref.initialAppMode;
  var dispatch = react_redux_1.useDispatch();

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isScenarioStateDone = _react_1$useState2[0],
      setIsScenarioStateDone = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(false),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      isImagesDone = _react_1$useState4[0],
      setIsImagesDone = _react_1$useState4[1];
  /* init scenario state */


  react_1.useEffect(function () {
    dispatch(scenario_actions_1.default.initScenarioState(initialScenarioState));
    setIsScenarioStateDone(true);
  }, [initialScenarioState]);
  /* init storage state */

  react_1.useEffect(function () {
    dispatch(storage_actions_1.default.setImages(images));
    setIsImagesDone(true);
  }, [initialScenarioState]);
  /* init appMode */

  react_1.useEffect(function () {
    if (!initialAppMode) return;
    dispatch(global_actions_1.default.setAppMode(initialAppMode));
  }, [initialAppMode]);
  return {
    ready: isScenarioStateDone && isImagesDone
  };
};

var ScenarioEditor = function ScenarioEditor(_ref2) {
  var initialScenarioState = _ref2.initialScenarioState,
      images = _ref2.images,
      initialAppMode = _ref2.initialAppMode,
      deploy = _ref2.deploy,
      save = _ref2.save;
  var appMode = react_redux_1.useSelector(global_selectors_1.selectAppMode);

  var _useInitScenarioEdito = useInitScenarioEditor({
    initialScenarioState: initialScenarioState,
    images: images,
    initialAppMode: initialAppMode
  }),
      ready = _useInitScenarioEdito.ready;

  if (!ready) return null;
  return react_1.default.createElement("div", null, react_1.default.createElement(scenario_editor_styles_1.StyledTopDiv, null, react_1.default.createElement(top_navigation_container_1.default, null), react_1.default.createElement(scenario_editor_styles_1.StyledButtonBoxDiv, null, react_1.default.createElement(save_scenario_button_container_1.default, {
    save: save
  }), react_1.default.createElement(deploy_scenario_button_container_1.default, {
    deploy: deploy,
    save: save
  }))), appMode === global_state_1.AppMode.Editor ? react_1.default.createElement(editor_content_component_1.default, null) : react_1.default.createElement(overview_content_container_1.default, null));
};

exports.default = with_store_hoc_1.default(ScenarioEditor);